import type { ReactNode } from 'react';
import { Box, Chip, Stack, Tooltip } from '@mui/material';
import { Row } from '../../../shared/Panel';
import { ORIGIN_APPEARANCE, type FieldOrigin } from './fieldOrigin';

/**
 * Znacznik pochodzenia przy polu (makieta FTL, pkt 16). Mały chip obok
 * wartości, pełne zdanie w dymku. Bez pochodzenia — nic (nie zgadujemy).
 */
export const OriginTag = ({ origin }: { origin: FieldOrigin | null }) => {
  if (!origin) return null;
  const appearance = ORIGIN_APPEARANCE[origin];
  return (
    <Tooltip title={appearance.hint}>
      <Chip
        size="small"
        variant="outlined"
        color={origin === 'demo' ? 'error' : 'default'}
        label={appearance.label}
        data-testid={`origin-${origin}`}
        aria-label={`Pochodzenie: ${appearance.label}. ${appearance.hint}`}
        sx={{ height: 20, fontSize: '0.7rem', color: origin === 'demo' ? undefined : 'text.secondary' }}
      />
    </Tooltip>
  );
};

/** Wiersz „etykieta — wartość” z pochodzeniem wartości na końcu. */
export const OriginRow = ({
  label,
  origin,
  children,
}: {
  label: string;
  origin: FieldOrigin | null;
  children: ReactNode;
}) => (
  <Row label={label}>
    <Stack direction="row" spacing={1} useFlexGap sx={{ alignItems: 'center', flexWrap: 'wrap' }}>
      <Box component="span">{children ?? '—'}</Box>
      <OriginTag origin={origin} />
    </Stack>
  </Row>
);
